import { useState } from 'react';

const slots = [5, 10, 15, 30, 45, 60, 90, 120];

const useTimeSlotsForSlider = (appendMinutesAfter60 = false) => {
  const [timeSlots, setTimeSlots] = useState();

  if (!timeSlots) {
    const showMinuteAfterValue = appendMinutesAfter60 ? 60 : 45;
    const value = slots.map(x => (x === 10 ? { label: ``, value: x } : { label: x > showMinuteAfterValue ? `${x}m` : `${x}`, value: x }));
    setTimeSlots(value);
  }

  return timeSlots;
};

export { useTimeSlotsForSlider };
